import { SolarPowerVariantOutlineIcon } from './SolarPowerVariantOutlineIcon';

/**
 * author: Google
 * id 3EF2EC63-DBE4-4825-9AFD-5567C0A081E2
 * name solar-power-variant-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/solar-power-variant-outline.svg
 * tags
 * - Home Automation 
 */
export const SolarEnergyOutlineIcon = SolarPowerVariantOutlineIcon;
export default SolarEnergyOutlineIcon